// removed by extract-text-webpack-plugin
module.exports = {"main":"index__main___u0rSi","stripe":"index__stripe___9C7Hh"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Stripe/index.styl
 ** module id = 206
 ** module chunks = 0
 **/